import React, { useState, useEffect } from "react";
import styles from "./home.module.css";
import Blue from "../../../Assets/About/blue.svg";
import Green from "../../../Assets/About/green.svg";
import flower from "../../../Assets/Homeimages/portflower.png";
import { FaPlus, FaMinus } from "react-icons/fa";
import { getHomeFaqs } from "../../../Services/APIrequests";
import defaultIMG from "../../../Assets/defaultimg.png";
import useStore from "../../../Store"; // <-- import store

const Faqs = ({ id }) => {
  const { Theme } = useStore(); // <-- get theme
  const [allFaqs, setAllFaqs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  useEffect(() => {
    const fetchAllFAQs = async () => {
      try {
        const response = await getHomeFaqs("");
        const allFaqsData = response?.data?.faqs || [];

        const validCategories = [
          ...new Set(
            allFaqsData
              .map((faq) => faq.faqCategoryName)
              .filter((name) => name !== null && name !== "")
          ),
        ];

        setAllFaqs(allFaqsData);
        setCategories(validCategories);
        if (validCategories.length > 0) {
          setSelectedCategory(validCategories[0]);
        }
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchAllFAQs();
  }, []);

  useEffect(() => {
    const filteredFaqs = allFaqs.filter(
      (faq) => faq.faqCategoryName === selectedCategory
    );
    setFaqs(filteredFaqs);
    setActiveIndex(null);
  }, [selectedCategory, allFaqs]);

  return (
    <section id={id}>
      <div className={styles.faqs_container}>
        {/* Left Image */}
        <div
          className={styles.faqs_image_container}
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <img
            src={Theme === "default" ?  Blue : Green } // <-- change image based on theme
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = defaultIMG;
            }}
            alt="FAQs Illustration"
            className={styles.faqa_img}
          />
        </div>

        {/* Right Text + FAQs */}
        <div
          className={styles.faqstext_container}
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <div className={styles.headerIcon}>
            <div className={styles.portimg_container}>
              <img
                src={flower}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = defaultIMG;
                }}
                alt="Flower Decoration"
              />
            </div>
            <p className={styles.portptext}>Faq Questions</p>
          </div>

          <h1 className={styles.faqh1}>
            Most Asked <br /> Questions?
          </h1>

          {/* Category Tabs */}
          <div className={styles.CalendartabsContainer}>
            {categories.map((cat, idx) => (
              <button
                key={idx}
                onClick={() => setSelectedCategory(cat)}
                className={`${styles.CalendartabButton} ${
                  selectedCategory === cat ? styles.CalendaractiveTab : ""
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Accordion */}
          <div className={styles.faqsq_container}>
            {faqs.length > 0 ? (
              faqs.map((faq, index) => (
                <div className={styles.faq_box} key={faq.id}>
                  <button
                    className={`${styles.accordion} ${
                      activeIndex === index ? styles.active : ""
                    }`}
                    onClick={() => handleClick(index)}
                  >
                    <p className={styles.faq_content}>{faq.question}</p>
                    <p className={styles.faq_content}>
                      {activeIndex === index ? <FaMinus /> : <FaPlus />}
                    </p>
                  </button>
                  <div
                    className={`${styles.panel} ${
                      activeIndex === index ? styles.show : ""
                    }`}
                  >
                    <p className={styles.faqs_answer}>{faq.answer}</p>
                  </div>
                </div>
              ))
            ) : (
              <p>No FAQs available.</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faqs;
